import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import SatelliteIcon from '@mui/icons-material/Satellite';

const solutionData = {
  id: 'satellite-imagery',
  name: 'Satellite Imagery',
  icon: <SatelliteIcon sx={{ fontSize: 60 }} />,
  description: 'Comprehensive satellite imagery solutions and analysis',
  overview: `Geomaps has partnership understandings with satellite imagery vendors and provide satellite imagery solutions to clients based on this business model. The products we offer include true image colour composites, multispectral imagery, thermal imagery, RADAR and SARS to name but a few. We also provide post processing services and data analysis of the satellite data e.g. image classification, terrain modelling, image rectification & mosaicking, vegetation mapping and hydrographic modelling.`,
  features: [
    {
      title: 'Multiple Image Types',
      description: 'True color composites, multispectral, thermal, RADAR, and SARS imagery',
    },
    {
      title: 'Post Processing',
      description: 'Advanced data analysis and image processing services',
    },
    {
      title: 'Image Classification',
      description: 'Automated classification and feature extraction',
    },
    {
      title: 'Terrain Modeling',
      description: 'Detailed terrain and elevation modeling from satellite data',
    },
    {
      title: 'Specialized Mapping',
      description: 'Vegetation mapping and hydrographic modeling capabilities',
    },
  ],
  benefits: [
    'Access to multiple satellite imagery sources',
    'Comprehensive data analysis',
    'Multiple imagery types available',
    'Advanced processing capabilities',
    'Specialized mapping solutions',
  ],
};

const SatelliteImagery = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default SatelliteImagery; 